import { gql } from '@apollo/client';

export const SITE_FIELDS = gql`
  fragment SiteFields on site {
    id
    apiUrl
    city
    createdBy
    dateCreated
    dateUpdated
    legacyId
    name
    prefix
    property
    rebelmouseId
    updatedBy
  }
`;
